module.exports = __webpack_public_path__ + "media/images/cows/Cow in postpartum period caring for newborn calves.jpeg";